import React, { Fragment, useState, useCallback, useEffect } from "react";
import Form from "@rjsf/core";
import validator from "@rjsf/validator-ajv8";
import PageHead from "../../components/pageHead";
import PhoneNumberInput from "../../components/phoneNumberInput";
import Textarea from "../../components/textarea";
import LoadingButton from "../../components/loadingButton";
import ErrorMessage from "../../components/errorMessage";
// import { checkScrollDirection } from "../../utils/menuNav";
import MobileNav from "../../components/mobileNav";
import useMediaQuery from "../../hooks/useMediaQuery";
import { useAxiosPrivate } from "../../hooks/useAxiosPrivate";
import formStyles from "../../components/form/style.module.css";
import styles from "./style.module.css";

const schema = {
  type: "object",
  required: ["name", "email", "message"],
  properties: {
    name: {
      title: "Full Name",
      type: "string",
    },
    email: {
      title: "Email Address",
      type: "string",
    },
    phone: {
      title: "Mobile Number",
      type: "string",
    },
    message: {
      title: "Message",
      type: "string",
    },
  },
};

const uiSchema = {
  "ui:classNames": `${formStyles.formInner} ${styles.form_inner}`,
  "ui:rootFieldId": "signup_step1",
  name: {
    "ui:classNames": `${formStyles.form_field} ${formStyles.col_4}`,
    "ui:placeholder": "eg. john doe",
  },
  email: {
    "ui:classNames": `${formStyles.form_field} ${formStyles.col_4} ${styles.email}`,
    "ui:placeholder": "youremail@gmail.com",
  },
  phone: {
    "ui:widget": PhoneNumberInput,
    "ui:classNames": `${formStyles.form_field} ${formStyles.col_4}`,
    "ui:placeholder": "1345 567-23-56",
  },
  message: {
    "ui:widget": Textarea,
    "ui:classNames": `${formStyles.form_field} ${formStyles.col_12}`,
    "ui:placeholder": "Enter your message here",
  },
  "ui:submitButtonOptions": {
    props: {
      className: formStyles.form_btn,
    },
    submitText: "Send",
  },
};

const widgets = {
  phone: PhoneNumberInput,
  message: Textarea,
};

const ContactUs = () => {
  const isMobile = useMediaQuery("(max-width: 767px)");
  const axiosPrivate = useAxiosPrivate();
  const [formData, setFormData] = useState({});
  const [isScrolling] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [success, setSuccess] = useState(false);

  const onFormSubmit = (data) => {
    setFormData(data);
    handleContactUs(data);
  };

  const handleContactUs = useCallback(async (data) => {
    setErrorMessage("");
    try {
      setLoading(true);
      let url = `/contact`;
      let options = {
        method: "POST",
        url,
        data,
      };
      await axiosPrivate(options)
        .then((response) => {
          if (response.data.status === 1) {
            setSuccess(true);
            setFormData({});
          }
          setLoading(false);
        })
        .catch((err) => {
          if (err.response) {
            setLoading(false);
            setErrorMessage(err.response.data.message);
          }
        });
    } catch (error) {
      setLoading(false);
    }
    // eslint-disable-next-line
  }, []);

  const handleScroll = (e) => {
    // const scrollDirection = checkScrollDirection(e);
    // setIsScrolling(scrollDirection);
  };

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        setSuccess(false);
      }, 5000);
    }
  }, [success]);

  return (
    <Fragment>
      <PageHead logo={isMobile} title="Contact Us" />
      <div className={styles.body} onScroll={handleScroll}>
        <div className={styles.contact_form}>
          <Form
            className={`${formStyles.form}`}
            schema={schema}
            uiSchema={uiSchema}
            widgets={widgets}
            formData={formData}
            validator={validator}
            showErrorList={false}
            omitExtraData={true}
            liveValidate={false}
            onSubmit={({ formData }) => {
              onFormSubmit(formData);
            }}
          >
            <div className={formStyles.form_actions}>
              <LoadingButton type="submit" loading={loading} title={"Send"} />
            </div>
          </Form>
          {errorMessage && <ErrorMessage message={errorMessage} mt />}
          {success && (
            <div className={styles.success}>
              <h2>Thank you for contacting us!</h2>
              <p>We will get back to you as soon as possible.</p>
            </div>
          )}
        </div>
      </div>
      {isMobile && <MobileNav defaultActive={true} isScrolling={isScrolling} />}
    </Fragment>
  );
};

export default ContactUs;
